<script setup lang="ts">
import { ButtonTertiaryIconSm } from "@easy/ui/buttons";
import { DesktopIcon, TabletIcon, MobileIcon } from "@easy/ui/icons";
import { usePagePreviewStore } from "../store/page-preview.store";
import { computed } from "vue";

const previewStore = usePagePreviewStore();

const scale = computed(() => Math.round(previewStore.scale * 100));
</script>

<template>
    <div class="flex justify-center items-center gap-4">
        <div class="flex items-center gap-0.5">
            <ButtonTertiaryIconSm
                class="hover:opacity-100 hover:ct-bg-3 !p-2"
                @click="previewStore.setViewport('desktop')"
                :class="{
                    'ct-bg-3 opacity-100': previewStore.viewport === 'desktop',
                    'opacity-80': previewStore.viewport !== 'desktop',
                }"
            >
                <DesktopIcon />
            </ButtonTertiaryIconSm>
            <ButtonTertiaryIconSm
                class="hover:opacity-100 hover:ct-bg-3 !p-2"
                @click="previewStore.setViewport('tablet')"
                :class="{
                    'ct-bg-3 opacity-100': previewStore.viewport === 'tablet',
                    'opacity-80': previewStore.viewport !== 'tablet',
                }"
            >
                <TabletIcon />
            </ButtonTertiaryIconSm>
            <ButtonTertiaryIconSm
                class="hover:opacity-100 hover:ct-bg-3 !p-2"
                @click="previewStore.setViewport('mobile')"
                :class="{
                    'ct-bg-3 opacity-100': previewStore.viewport === 'mobile',
                    'opacity-80': previewStore.viewport !== 'mobile',
                }"
            >
                <MobileIcon />
            </ButtonTertiaryIconSm>
        </div>

        <div class="h-8 w-[1px] ct-bg-3"></div>

        <div class="flex items-center gap-0.5">
            <ButtonTertiaryIconSm
                @click="previewStore.decrementScale()"
                class="text-xl !leading-[0.875rem] !p-2"
                >-</ButtonTertiaryIconSm
            >
            <span class="text-sm ct-bg-3 min-w-[54px] rounded-md px-2 py-1 text-center"
                >{{ scale }}%</span
            >
            <ButtonTertiaryIconSm
                @click="previewStore.incrementScale()"
                class="text-xl !leading-[0.875rem] !p-2"
                >+</ButtonTertiaryIconSm
            >
        </div>
    </div>
</template>
